module.exports = __webpack_public_path__ + "img/logo2.d4e81775.png";